import { ErrorPage } from '@app/components/error-page';
import { FileQuestion } from 'lucide-react';
import { useTranslation } from 'react-i18next';

function NotFound() {
    const { t } = useTranslation();

    return (
        <ErrorPage
            statusCode={404}
            title={t('pages.errors.404.title')}
            description={t('pages.errors.404.description')}
            icon={<FileQuestion className="text-muted-foreground h-10 w-10" />}
        />
    );
}

// noinspection JSUnusedGlobalSymbols
export default NotFound;
